import React from "react";
import Body from "../components/v2/Body";
import pwlogo from '../imgs/pwlogo.jpeg';
import gclogo from '../imgs/gclogo.jpeg';
import nslogo from '../imgs/nslogo.jpeg';

import "./About.css";

const About = () => {
    const mainContent = {
        'title': 'Hello again!',
        'description': 'I have worked for some amazing companies and with some awesome people in my career.'
    }
    const recentWork = [
         {
            'title': 'Engineer III @ Pipeworks',
            'description': 'At Pipeworks, my responsibilities focus on gameplay, systems, and UI work in multiplayer settings, so it is a must to always be thinking about the network architecture.  '
                    + 'I have worked using Unreal Engine 5 and a proprietary engine on the games to get them working and running well on current gen consoles(Xbox Series X/S, PS5) and PC.  '
                    + 'My team and I have owned multiple features and we constantly collaborate with the other disciplines during the initial implementations, improvements, and of course the bug squashing phases.',
            'img': pwlogo
        },
        {
            'title': 'Game Producer @ Game Circus',
            'description': 'My first step into game development was as a producer at Game Circus.  Seeing things from a producer\'s point of view helped me learn about proper communication, '
                    + 'release management, and monitoring.  The knowledge I gained during my brief time as a producer has helped me work with everyone in my current team.',
            'img': gclogo
        },
        {
            'title': 'Software Engineer / Technical Lead @ NetSpend Corporation',
            'description': 'I worked alongside an amazing team as both an engineer and as the team\'s technical lead.  '
                    + 'Together we created a microservice, designed and implemented an automated regression testing suite, and consistently enhanced the company\'s data management tool.',
            'img': nslogo
        },
    ]
    return (
        <div className="about">
            <Body main={mainContent} details={recentWork}/>
        </div>
    );
     
};
 
export default About;